import { Component, Input, OnInit } from '@angular/core';
import { PageElementViewModel, ConferenceViewModel } from 'src/app/_models/generatedModels';

@Component({
  selector: 'bxl-conference-banner-rotator',
  templateUrl: 'conference-banner-rotator.component.html',
})
export class ConferenceBannerRotatorComponent implements OnInit {
  initialized = false;
  url: string;
  @Input() conference: ConferenceViewModel;
  @Input() element: PageElementViewModel;
  constructor() {}

  ngOnInit(): void {
    var urlList = this.element.data;
    var urlArray = urlList.split(',');
    var index = this.getRandomArbitrary(0, urlArray.length);
    this.url = urlArray[index];
    this.initialized = true;
  }

  getRandomArbitrary(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }
}
